define.alias("ember-svg-jar/helpers/svg-jar", "media/helpers/svg-jar");